import api from '../../../lib/Api'
import * as actions from './actions'
import { addNotification } from '../../notifications'

export const onFileChange = event => {
  return async function(dispatch) {
    const file = event.target.files[0]
    dispatch(actions.setSelectedFile(file))
  }
}

export const handleUpload = ({ file }) => {
  return async function(dispatch) {
    dispatch(actions.setIsSubmitting())
    const bodyFormData = new FormData()
    bodyFormData.set('sitesPreferences', file)

    try {
      const response = await api.patch('sites/preferences', bodyFormData)
      response.file = file
      dispatch(actions.setSubmittingSuccess(response))
      dispatch(
        addNotification({
          color: 'success',
          text: `site Preferences were updated. Check the CSV file`,
        }),
      )
    } catch (error) {
      const { response } = error || {}
      const { status, data } = response || {}
      const {
        detail = "Something's gone wrong while uploading file. Please try again or file a ticket for assistance.",
      } = data || {}
      const errorMsg = detail
      dispatch(actions.setSubmittingError(errorMsg, file))

      dispatch(
        addNotification({
          color: 'danger',
          text: errorMsg,
        }),
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/sitePreferences/operations.js